// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M6 4L10 8L6 12'];
